import React from 'react';

export default (props) => {
  return (
    <svg
      width="24px"
      height="24px"
      viewBox="0 0 24 24"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      role="graphics-symbol"
      {...props}
    >
      <defs>
        <polyline
          id="path-2"
          points="9 12.665696 10.9548373 14.2780762 15.081716 9.19042969"
        />
      </defs>
      <g
        id="Symbols:-Icons"
        stroke="none"
        strokeWidth={1}
        fill="none"
        fillRule="evenodd"
      >
        <g id="icons/tile-types/black/event_delay">
          <rect
            id="Container"
            fillOpacity={0}
            fill="#FFFFFF"
            x={0}
            y={0}
            width={24}
            height={24}
          />
          <polygon
            id="Polygon"
            fill="#000000"
            points="16.5563492 1 23 7.44365081 23 16.5563492 16.5563492 23 7.44365081 23 1 16.5563492 1 7.44365081 7.44365081 1"
          />
          <rect
            id="Rectangle"
            fill="#FFFFFF"
            x={6}
            y={6}
            width={12}
            height={12}
            rx={2}
          />
          <g id="Line-2" strokeLinecap="round" strokeLinejoin="round">
            <use stroke="#FFFFFF" strokeWidth={5} xlinkHref="#path-2" />
            <use stroke="#000000" strokeWidth={2} xlinkHref="#path-2" />
          </g>
        </g>
      </g>
    </svg>
  );
};
